import { useState } from "react";

import type { ThinkingView } from "../../api/thinking";

export function IntroStepView({
  view,
  busy,
  onStart,
}: {
  view: ThinkingView;
  busy: boolean;
  onStart: (extraTime: boolean) => void;
}) {
  const [extraTime, setExtraTime] = useState(false);
  const multiplier = view.intro?.extra_time_multiplier ?? 1;
  return (
    <section>
      <h1>Three short questions</h1>
      <p>
        <strong>Please answer these yourself.</strong> There's no code and no right answer; we want
        to see how you think. About 15 minutes.
      </p>
      <p>
        <strong>Recording is on:</strong> we record typing timings, pastes (their length only) and
        when you leave this tab, never what you type until you submit it. Some parts are timed and
        submit automatically. You can't go back to an earlier answer.
      </p>
      <label className="checkbox">
        <input
          type="checkbox"
          checked={extraTime}
          onChange={(e) => setExtraTime(e.target.checked)}
        />
        I need more time to type ({multiplier}× on timed parts — this never counts against you)
      </label>
      <button type="button" disabled={busy} onClick={() => onStart(extraTime)}>
        Start
      </button>
    </section>
  );
}
